import { _get, _getAxios, _getAxiosWithoutInterceptor } from "./serviceMain";

export function getPharmacyInfo(groupCode: string, storeCode: string, card: string)  {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card
      });

  const url = '/v3/stores/cardfiltered';

  return _getAxios(url, "GET_PHARMAINFO_TIME", "pharmacyInfo", queryParams);

  };

export function getPharmacyInfoWithoutInterceptor(groupCode: string, storeCode: string, card: string)  {

const queryParams = new URLSearchParams({
    groupCode: groupCode,
    storeCode: storeCode,
    card: card
    });

const url = '/v3/stores/cardfiltered';

return _getAxiosWithoutInterceptor(url, "GET_PHARMAINFO_TIME", "pharmacyInfo", queryParams);

};